import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { BackButton } from './BackButton'

type PageHeaderProps = {
  title: ReactNode
  description?: ReactNode
  actions?: ReactNode
  eyebrow?: ReactNode
  backTo?: string
  onBack?: () => void
}

export function PageHeader({ title, description, actions, eyebrow, backTo, onBack }: PageHeaderProps) {
  return (
    <header className="relative mb-6 overflow-hidden rounded-xl border border-primary/15 bg-gradient-to-r from-primary/[0.08] via-primary/[0.03] to-card px-2 py-4 shadow-xs sm:px-5 dark:from-primary/15 dark:via-primary/[0.06]">
      <div aria-hidden className="pointer-events-none absolute -right-16 -top-20 size-56 rounded-full bg-brand-sky/10 blur-3xl" />
      <div className="relative flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between sm:gap-4">
        <div className="flex min-w-0 items-start gap-3 sm:flex-[1_1_20rem] sm:items-center">
          {backTo ? <BackButton to={backTo} onClick={onBack} className="shrink-0" /> : null}
          <div className="min-w-0 space-y-1">
            {eyebrow ? <div className="text-xs font-medium text-muted-foreground">{eyebrow}</div> : null}
            <h1 className="break-words text-xl font-semibold tracking-tight sm:text-xl">{title}</h1>
            {description ? <div className="text-sm text-muted-foreground">{description}</div> : null}
          </div>
        </div>
        {actions ? (
          <div
            className={cn(
              'flex max-w-full flex-wrap items-center gap-2',
              // Mobil: başlığın altında, eşit genişlikte 2'li ızgara; yalnız ikon butonlar sabit kalır.
              'max-sm:w-full max-sm:border-t max-sm:border-primary/10 max-sm:pt-3 max-sm:*:flex-[1_1_calc(50%-0.25rem)]',
              'max-sm:[&>[class~=size-8]]:flex-none max-sm:[&>[class~=size-9]]:flex-none',
            )}
          >
            {actions}
          </div>
        ) : null}
      </div>
    </header>
  )
}
